const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MobileAppHandlerQuery: any = {
    GetListMobileApp: Backofficebff + '/v1/mobilpanelapplication/listofapplication',
    GetListMobileAppV2: Backofficebff + '/v2/mobilepanel/application-list',
};
